// Helpers
import _ from 'lodash';

// Types
import type {
  $ModelClasses,
} from './models';

const forbiddenSlugs: Array<string> = ['api', 'socket', 'admin', 'static', 'login', 'profile', 'page', 'regions', 'content', 'championship', 'championships', 'regatta', 'regattas'];

const slugModelWithRegionSeasonNames: Array<string> = ['Regatta', 'Championship'];
const slugModelNames: Array<string> = ['CustomPage'];

const verifySlug = async ({
  models,
  RegionSeasonId,
  Slug,
}: {
  models: $ModelClasses;
  RegionSeasonId?: string;
  Slug: null | string;
}): Promise<boolean> => {
  let itemsFound = 0;

  for (let index = 0; index < slugModelWithRegionSeasonNames.length; index += 1) {
    const modelName = slugModelWithRegionSeasonNames[index];

    const request: {
      where: {
        RegionSeasonId?: string;
        Slug: null | string;
      };
    } = {
      where: {
        RegionSeasonId: undefined,
        Slug,
      },
    };

    if (RegionSeasonId) {
      request.where = {
        RegionSeasonId,
        Slug,
      };
    }

    itemsFound += await models[modelName].count(request);
  }

  for (let index = 0; index < slugModelNames.length; index += 1) {
    const modelName = slugModelNames[index];

    const request = {
      where: {
        Slug,
      },
    };

    itemsFound += await models[modelName].count(request);
  }

  return itemsFound === 0;
};

/* eslint-disable-next-line complexity,import/prefer-default-export */
export const validateSlug = async ({
  currentValue,
  models,
  newValue,
  RegionSeasonId,
}: {
  currentValue: null | string;
  models: $ModelClasses;
  newValue?: null | string;
  RegionSeasonId?: string;
}): Promise<null | string> => {
  let Slug: null | string = newValue ? _.kebabCase(newValue.toLowerCase()) : null;

  if (currentValue === Slug) {
    return Slug;
  }

  if (Slug !== null) {
    let valueUnique = false;

    while (!valueUnique) {
      Slug = Slug || '';

      if (forbiddenSlugs.indexOf(Slug) !== -1) {
        Slug = `${Slug}_`;
      }

      valueUnique = await verifySlug({
        models,
        RegionSeasonId,
        Slug,
      });

      if (!valueUnique) {
        Slug = `${Slug}_`;
      }
    }

    return Slug;
  }

  return null;
};
